import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { EditBridgePoolDialogBody, EditBridgePoolDialogProps, EditBridgePoolDialogState } from '~src/app/content/EditBridgePoolDialog';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { EdgePool } from '~src/ts/resources/EdgePool';
import { IUpdateEdgePoolParams, IUpdateEdgePoolResult } from '~src/ts/ServerApi/requests/UpdateEdgePoolRequest';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { UserDefinedPoolModel } from '../types/PoolModel';

export type EditPoolButtonProps = Readonly<{
  pool: UserDefinedPoolModel;
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshEdgePools: () => void;
}>;

export function EditPoolButton(props: EditPoolButtonProps) {
  return (
    <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'pool-edit-cell'}>
      <ButtonWidget
        title={Messages.edit()}
        buttonType={ButtonType.Icon}
        testId={'edit-pool-button'}
        onClick={() => openEditPoolDialog(props.pool, props.existingPoolNames, props.siteId, props.refreshEdgePools)}
      >
        <img src={imgPath('pencil_14px_small.svg')} alt={Messages.edit()} />
      </ButtonWidget>
    </span>
  );
}

function openEditPoolDialog(pool: UserDefinedPoolModel, existingPoolNames: ReadonlyArray<string>, siteId: string, refreshEdgePools: () => void) {
  const action = (_: EditBridgePoolDialogProps, state: EditBridgePoolDialogState) => {
    const updateProps: IUpdateEdgePoolParams = {
      poolId: pool.id,
      displayName: state.poolName,
      domainChange: null,
      agentChange: null,
      siteId: siteId,
      bridgeSettingsVersion: '0'
    };

    EdgePool.updatePool(updateProps)
      .then((result: IUpdateEdgePoolResult) => {
        refreshEdgePools();
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.bridgeSiteSettingsEditPoolSuccess() });
        }
        if(result.error) {
          // TODO - ndepass 9/20/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.errorUnknown() });
        }
      });
    return Promise.resolve();
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.bridgeSiteSettingsEditPool(),
    bodyComponent: EditBridgePoolDialogBody,
    initialBodyProps: { existingPoolNames },
    initialDialogState: { poolName: pool.displayName, hasError: false },
    actionName: Messages.save(),
    action: action,
    actionDisabled: (_, state: EditBridgePoolDialogState) => state.poolName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
